// extracted by mini-css-extract-plugin
module.exports = {"Quote":"CourseQuote_Quote__qKesk","Author":"CourseQuote_Author__S8uiX"};